import { GroupWeeklySchedule, WeeklySchedule } from '@schooly/api';

export function groupSchedulesToWeeklySchedules(
  schedules: GroupWeeklySchedule[],
  displayGroup: WeeklySchedule['groups'][number],
): WeeklySchedule[] {
  return schedules.map((schedule) => ({
    ...schedule,
    groups: [displayGroup],
    facilities: [],
    schedule: schedule.schedule.map((day) => ({
      ...day,
      slots: day.slots.map((slot) => ({
        time_slot_id: slot.time_slot_id,
        allocations: [{ group_id: displayGroup.id, room_id: slot.room_id }],
      })),
    })),
  }));
}
